import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Router } from "@angular/router";
import { DarkSkyResult } from './weather.models';

@Injectable()
export class WeatherService
{
    readonly ROOT_URL = '';

    // constructor
    constructor(private _http: HttpClient, private router: Router, @Inject('BASE_URL') private baseUrl: string)
    {

    }

	public getCurrentForecast(lat: number, lng: number)
	{
		var _urlParts = this.router.url.split('/');
		let _area = _urlParts[1] || null;
		let _controller = _urlParts[2] || null;

		let _userLang = localStorage.getItem("user_lang") || 'it';

		const _httpOptions = {
			params: new HttpParams()
				.set('CurrentArea', _area)
				.set('CurrentController', _controller)
		};

		return this._http.get<DarkSkyResult>(`${this.baseUrl}api/shared/shared/GetLocalWeather?Latitude=${lat}&Longitude=${lng}&Lang=${_userLang}`, _httpOptions);
	}
}